import React, { useState, useEffect } from 'react';
import { SimpleForm, TextInput, Create, SelectInput } from 'react-admin';
import Grid from '@material-ui/core/Grid';

const dataType = [
    { value: 'url', description: 'URL' },
    { value: 'file', description: 'File' }
];

const dataState = [
    { value: 'active', description: 'Activo' },
    { value: 'inactive', description: 'Inactivo' }
];

const MeansCreate = (props) => {
    const [typeValue, setTypeValue] = useState([])
    const [typeValueValidated, setTypeValueValidated] = useState("")

    const handleChangeType = (value) => {
        const auxObj = Object.values(value)
        const auxArr = []
        for (let i = 0; i < auxObj.length; i++) {
            if (typeof auxObj[i] === "string") {
                auxArr.push(auxObj[i])
            }
        }
        setTypeValueValidated(auxArr.join(""))
    }

    useEffect(() => {
        handleChangeType(typeValue)
    }, [typeValue])

    return (
        <Create title={"Crear Recursos"} {...props}>
            <SimpleForm>
                <Grid container spacing={16}>
                    <Grid item xs={12} md={6}>
                        <TextInput source="description" label="Descripción" fullWidth />
                        <SelectInput 
                            onChange={(e) => setTypeValue(e)} 
                            label="Tipo" 
                            choices={dataType} 
                            optionText="description" 
                            source="type" 
                            optionValue="value" 
                            fullWidth={true} 
                        /><br></br>
                        {typeValueValidated === "url" ? (
                            <TextInput source="path" label="URL" fullWidth={true} />
                        ) : typeValueValidated === "file" ? (
                            <>
                                <TextInput source="path" label="Path del archivo" fullWidth={true} />
                                <small style={{ color: '#666', display: 'block', marginTop: '-8px' }}>
                                    Nota: Para subir archivos, primero crea el recurso y luego edítalo para subir el archivo desde S3.
                                </small>
                            </>
                        ) : null}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextInput source="position" label="Posición" fullWidth />
                        <SelectInput 
                            label="Estado" 
                            choices={dataState} 
                            optionText="description" 
                            source="status" 
                            optionValue="value" 
                            fullWidth={true} 
                        />
                    </Grid>
                </Grid>
            </SimpleForm>
        </Create>
    )
}

export default MeansCreate;